import CustomDialog from 'Components/CustomDialog'
import CustomLoadingButton from 'Components/CustomLoadingButton'
import { useImportSingleTariffMutation } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import SnackbarUtil from 'Util/Snackbar'
import UploadIcon from '@mui/icons-material/Upload'
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  TextField,
  Typography
} from '@mui/material'
import { useId, useState } from 'react'
import { t } from 'ttag'

interface TariffImportDialogProps {
  open: boolean
  handleClose: () => void
}

export function TariffImportDialog({ open, handleClose }: Readonly<TariffImportDialogProps>) {
  const [importSingleTariff, { isLoading: isImportLoading }] = useImportSingleTariffMutation()
  const [tariffId, setTariffId] = useState('')

  const dialogTitleId = useId()

  const importTariff = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    importSingleTariff({ id: tariffId })
      .unwrap()
      .then(() => {
        SnackbarUtil.success(t`Tariff successfully imported.`)
        handleClose()
      })
      .catch(() => {
        SnackbarUtil.error(t`There was an error importing the tariff.`)
      })
  }

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle id={dialogTitleId}>{t`Are you sure?`}</DialogTitle>
      <Box component="form" onSubmit={importTariff}>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Typography
                component="span"
                color="text.primary"
              >{t`Are you sure you want to import tariff?`}</Typography>
            </Box>
            <Box mt={2}>
              <Typography
                component="span"
                color="text.primary"
              >{t`Tariff's id should be from the staging environment.`}</Typography>
            </Box>
            <Box mt={2}>
              <FormControl fullWidth size="small">
                <TextField
                  required
                  name="tariff_id"
                  value={tariffId}
                  label={t`Tariff's id`}
                  onChange={e => setTariffId(e.target.value)}
                />
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: 'text.primary' }}>
            {t`Cancel`}
          </Button>
          <CustomLoadingButton
            size="medium"
            type="submit"
            variant="contained"
            isLoading={isImportLoading}
            startIcon={<UploadIcon />}
            endIcon={null}
          >
            {t`Import tariff`}
          </CustomLoadingButton>
        </DialogActions>
      </Box>
    </CustomDialog>
  )
}
